<template>
	<v-container class="content" fluid>
		<v-layout column>
			<v-flex>
				<h1 class="display-1">Adaptermeldungen</h1>
			</v-flex>
			<v-flex xs12 sm6>
				<v-text-field v-model="suchbegriff" placeholder="Suchen" clearable></v-text-field>
			</v-flex>
			<v-flex xs12>
				<v-data-table
					:headers="logHeaders"
					:items="filteredLogs"
					:loading="dataLoading"
					item-key="logId"
					hide-actions
					class="elevation-1"
				>
					<v-progress-linear
						slot="progress"
						color="accent"
						indeterminate
					></v-progress-linear>
					<template slot="items" slot-scope="props">
						<tr>
							<td class="text-xs-left">{{ props.item.level }}</td>
							<td class="text-xs-left">
								{{ props.item.date | formatTechnicalDateAndTime }}
							</td>
							<td class="text-xs-left">
								{{ props.item.message }} {{ props.item.exception }}
							</td>
							<td class="text-xs-left">{{ props.item.logger }}</td>
						</tr>
					</template>
				</v-data-table>
			</v-flex>
			<v-flex>
				<v-btn class="blexon-button" @click="loadLogs()">Mehr laden...</v-btn>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import httpClient from "../store/httpClient";

export default {
	data() {
		return {
			suchbegriff: "",
			dataLoading: false,
			loadedUntil: 0,
			logs: [],
			logHeaders: [
				{
					value: "level",
					text: "Level",
					sortable: false,
					width: "10%",
				},
				{
					value: "date",
					text: "Datum",
					sortable: false,
					width: "10%",
				},
				{
					value: "message",
					text: "Meldung",
					sortable: false,
					width: "60%",
				},
				{
					value: "logger",
					text: "Adapter",
					sortable: false,
					width: "20%",
				},
			],
		};
	},

	computed: {
		filteredLogs() {
			if (this.suchbegriff === "" || this.suchbegriff === null) {
				return this.logs;
			} else {
				return this.logs.filter((l) => l.message.includes(this.suchbegriff));
			}
		},
	},

	created() {
		this.loadLogs();
	},

	methods: {
		/**
		 * Loads all logs
		 * from the server.
		 */
		async loadLogs() {
			try {
				this.dataLoading = true;
				let response = await httpClient().get(
					`api/Log/GetLogs?start=${this.loadedUntil}&fertigerId=${this.$route.params.fertigerId}`
				);
				this.loadedUntil += 200;
				this.logs.push(...response.data);
			} catch (err) {
				console.log(err);
			} finally {
				this.dataLoading = false;
			}
		},
	},
};
</script>
